import { assetsUrl } from "../../common/config";

export const defaultTodoImg = `${assetsUrl}/dashboard/defaultToDo.svg`;

export const defaultContentImg = `${assetsUrl}/dashboard/defaultContent.svg`;
export const defaultContentBackgroundImg = `${assetsUrl}/dashboard/contentBackgroundImage.png`;

export const successSubscriptionImg = `${assetsUrl}/success_subscription.svg`;
export const successSubscriptionRibbonImg = `${assetsUrl}/success-subscription-ribbon.svg`;
export const personImg = `${assetsUrl}/person.svg`;

export const dashboardMigrationImg = `${assetsUrl}/dashboard/migrationSuccess.png`;

export const updateGoalAlertImg = `${assetsUrl}/home/icons/Alert.svg`;

export const eventDetailsImagePath = `${assetsUrl}/events+/eventDetailsBackgorundImage.jpg`;
export const lifeTimeCardImage = `${assetsUrl}/tools/emptyLifetimeIncome.svg`;
